import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/media'

const CmsMediaApiV2 = {

  /**
   * Get list of Cms Media
   * Invoke `GET api/v2/admins/cms/media'
   */
  get: async ({ params }) => {
    const path = API_PATH

    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Create Cms Media
   * Invoke `POST api/v2/admins/cms/media'
   */
  create: async ({ payload }) => {
    const path = API_PATH

    const response = await axios.post(path, payload)
    return response
  }
}

export default CmsMediaApiV2
